export default {
  Region: "ap-northeast-1",
  UserPoolId: "ap-northeast-1_KqNfV6OO4",
  ClientId: "7da7fruk674bbi1jtb4re96lej",
  IdentityPoolId: "ap-northeast-1:086698d1-7b07-4c01-892b-34d430e502c1"
};
